module.exports = __webpack_public_path__ + "static/media/RE.e7bd2250.svg";